import { gql, useMutation } from '@apollo/client'
import { IChannel, IChannelCreateInput } from '@dtos/Channel'

export const CHANNEL_CREATE = gql`
  mutation ChannelCreate($subject: String!, $text: String!) {
    channelCreate(
      input: {
        subject: $subject
        text: $text
        clientMutationId: "channel-create"
      }
    ) {
      channel {
        id
        subject
        createdAt
      }
      errors
    }
  }
`

interface IChannelCreateResult {
  channelCreate: {
    channel: IChannel | null
    errors: string[]
  }
}

export const useChannelCreate = () => {
  const [create, { loading, error }] = useMutation<IChannelCreateResult>(
    CHANNEL_CREATE,
    {
      refetchQueries: ['GetChannels'],
      awaitRefetchQueries: true,
    },
  )

  const handleCreate = async (input: IChannelCreateInput) => {
    const response = await create({ variables: input })
    return response.data?.channelCreate
  }

  return { handleCreate, loading, error }
}
